import { render, staticRenderFns } from "./como-login-code.vue?vue&type=template&id=0f1bed85"
import script from "./como-login-code.vue?vue&type=script&lang=ts"
export * from "./como-login-code.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f1bed85')) {
      api.createRecord('0f1bed85', component.options)
    } else {
      api.reload('0f1bed85', component.options)
    }
    module.hot.accept("./como-login-code.vue?vue&type=template&id=0f1bed85", function () {
      api.rerender('0f1bed85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/como-login-code.vue"
export default component.exports